import styled from 'styled-components';

export const InfoPane = styled.div`
    flex-grow: 0;
    margin-right: .65em;
`;

export const ButtonPane = styled.div`
    align-items: center;
    display: inline-flex;
    flex-grow: 1;
    .item-action {
        font-size: 1.6em;
        margin-left: .4em;
    }
    .btn-group {
        display: inline-flex;
        align-items: center;
        margin-left: auto;
        button {
            line-height: 1;
        }
    }
`;

export const Toolbar = styled.div`
    align-items: center;
    background-color: var(--theme-secondary);
    display: flex;
    margin: 0;
    padding: .4em;
    .inx-io-icon, .ico-product {
        font-size: 0.9em;
    }
    .print-this & {
        border-width: 0 0 1px 0;
    }
`;
